'use client';

import * as React from 'react';

import { RecoverableError } from '../components/recoverable-error';

// Root-level boundary. Catches errors thrown anywhere below the root layout —
// crucially including (inbox)/layout.tsx, whose server render re-runs on the
// router.refresh() the realtime clients fire on socket reconnect. Without this
// such a throw fell through to global-error.tsx (the bare "Something went
// wrong" screen). Self-heals on reconnect via RecoverableError.
export default function RootError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.JSX.Element {
  return <RecoverableError {...props} scope="root" />;
}
